module.exports = __webpack_public_path__ + "static/media/wuPhoto.2615f320.jpeg";